module.exports = __webpack_public_path__ + "img/CustomerIconNEW3.61a5b1e9.png";